// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"cf2c138d","453":"60481dcf"}[chunkId] + ".chunk.js";
};